import apiClient from './apiClient';

const BASE = '/api/badges';

export const badgesApi = {
  getAllTemplates: (includeInactive = false) =>
    apiClient.get(`${BASE}/templates`, { params: { includeInactive } })
      .then(r => r.data),

  getTemplate: (id) =>
    apiClient.get(`${BASE}/templates/${id}`)
      .then(r => r.data),

  createTemplate: (data) =>
    apiClient.post(`${BASE}/templates`, data)
      .then(r => r.data),

  updateTemplate: (id, data) =>
    apiClient.put(`${BASE}/templates/${id}`, data)
      .then(r => r.data),

  deleteTemplate: (id) =>
    apiClient.delete(`${BASE}/templates/${id}`),

  getAllRules: () =>
    apiClient.get(`${BASE}/rules`)
      .then(r => r.data),

  createRule: (data) =>
    apiClient.post(`${BASE}/rules`, data)
      .then(r => r.data),

  /**
   * Atomically sync the award rule for a badge template.
   * Replaces ALL existing rules for the template with a single new rule
   * (or deletes all rules if eventType is MANUAL_AWARD).
   * Use this when EDITING a badge to prevent orphaned rules.
   */
  syncRule: (templateId, data) =>
    apiClient.put(`${BASE}/templates/${templateId}/rule`, data)
      .then(r => r.data),

  deleteRule: (id) =>
    apiClient.delete(`${BASE}/rules/${id}`),

  manualAward: (data) =>
    apiClient.post(`${BASE}/award`, data)
      .then(r => r.data),

  getUserBadges: (userId) =>
    apiClient.get(`${BASE}/users/${userId}`)
      .then(r => r.data),

  getUserBadgesBatch: (userIds) =>
    apiClient.get(`${BASE}/users/batch`, { params: { userIds: userIds.join(',') } })
      .then(r => r.data),

  getUserBadgeCount: (userId) =>
    apiClient.get(`${BASE}/users/${userId}/count`)
      .then(r => r.data),

  getTemplateAwardCounts: () =>
    apiClient.get(`${BASE}/templates/award-counts`)
      .then(r => r.data),

  getAllSeries: () =>
    apiClient.get(`${BASE}/series`)
      .then(r => r.data),

  createSeries: (data) =>
    apiClient.post(`${BASE}/series`, data)
      .then(r => r.data),

  updateSeries: (id, data) =>
    apiClient.put(`${BASE}/series/${id}`, data)
      .then(r => r.data),

  deleteSeries: (id) =>
    apiClient.delete(`${BASE}/series/${id}`),

  getSeriesTemplates: (id) =>
    apiClient.get(`${BASE}/series/${id}/templates`)
      .then(r => r.data),

  getSeriesEligibility: (id) =>
    apiClient.get(`${BASE}/series/${id}/eligibility`)
      .then(r => r.data),

  getTemplateEligibility: (id) =>
    apiClient.get(`${BASE}/templates/${id}/eligibility`)
      .then(r => r.data),

  sweepAwardTemplate: (id) =>
    apiClient.post(`${BASE}/templates/${id}/sweep`)
      .then(r => r.data),

  sweepAwardSeries: (id) =>
    apiClient.post(`${BASE}/series/${id}/sweep`)
      .then(r => r.data),

  getPublicSeries: (id) =>
    apiClient.get(`${BASE}/public/series/${id}`)
      .then(r => r.data),

  getPublicSeriesTemplates: (id) =>
    apiClient.get(`${BASE}/public/series/${id}/templates`)
      .then(r => r.data),
};
